import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getCreditLimitRequests = createAsyncThunk(
  "creditLimit/getCreditLimitRequests",
  async (dealCategoryId, { rejectWithValue }) => {
    try {
      const params = dealCategoryId ? { dealCategoryId } : {};
      const response = await axios.get("/api/business/creditLimit/requests", { params });
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const createCreditLimitRequest = createAsyncThunk(
  "creditLimit/createCreditLimitRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/business/creditLimit/request", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const updateCreditLimitRequest = createAsyncThunk(
  "creditLimit/updateCreditLimitRequest",
  async ({ requestId, payload }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/business/creditLimit/request/${requestId}`, payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const getAvailableEnterprises = createAsyncThunk(
  "creditLimit/getAvailableEnterprises",
  async (dealCategoryId, { rejectWithValue }) => {
    try {
      const params = dealCategoryId ? { dealCategoryId } : {};
      const response = await axios.get("/api/business/creditLimit/availableEnterprises", { params });
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const creditLimitSlice = createSlice({
  name: "creditLimit",
  initialState: {
    loading: false,
    submitLoading: false,
    requests: [],
    availableEnterprises: [],
    error: null,
    success: null,
  },
  reducers: {
    clearCreditLimitState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // getCreditLimitRequests
    builder.addCase(getCreditLimitRequests.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getCreditLimitRequests.fulfilled, (state, action) => {
      state.loading = false;
      state.requests = Array.isArray(action.payload) ? action.payload : [];
    });
    builder.addCase(getCreditLimitRequests.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload || "Failed to fetch credit limit requests";
    });

    // createCreditLimitRequest
    builder.addCase(createCreditLimitRequest.pending, (state) => {
      state.submitLoading = true;
      state.error = null;
    });
    builder.addCase(createCreditLimitRequest.fulfilled, (state) => {
      state.submitLoading = false;
      state.success = "Credit limit request submitted successfully";
    });
    builder.addCase(createCreditLimitRequest.rejected, (state, action) => {
      state.submitLoading = false;
      state.error = action.payload || "Failed to submit credit limit request";
    });

    // updateCreditLimitRequest
    builder.addCase(updateCreditLimitRequest.pending, (state) => {
      state.submitLoading = true;
      state.error = null;
    });
    builder.addCase(updateCreditLimitRequest.fulfilled, (state) => {
      state.submitLoading = false;
      state.success = "Credit limit request updated successfully";
    });
    builder.addCase(updateCreditLimitRequest.rejected, (state, action) => {
      state.submitLoading = false;
      state.error = action.payload || "Failed to update credit limit request";
    });

    // getAvailableEnterprises
    builder.addCase(getAvailableEnterprises.fulfilled, (state, action) => {
      state.availableEnterprises = Array.isArray(action.payload) ? action.payload : [];
    });
  },
});

export const { clearCreditLimitState } = creditLimitSlice.actions;
export default creditLimitSlice.reducer;
